import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private crudService: CrudService) { }

  SaveProfileDetails(ProfileData: any): Observable<any> {
    return this.crudService.post<any>('Profile/SaveProfileDetails', ProfileData);
  }

  SaveMailDetails(ProfileMailData: any): Observable<any> {
    return this.crudService.post<any>('Profile/SaveMailDetails', ProfileMailData);
  }

  GetProfileDetailsById(TMCNo: string): Observable<any> {
    return this.crudService.get<any>('Profile/GetProfileDetailsById?TMCNo=' + TMCNo);
  }

  GetProfileMailDetailsById(TMCNo: string): Observable<any> {
    return this.crudService.get<any>('Profile/GetProfileMailDetailsById?TMCNo=' + TMCNo);
  }

  GetSBUHeadDetails(SBUCode: string): Observable<any> {
    return this.crudService.get<any>('Profile/GetSBUHeadDetails?SBUCode=' + SBUCode);
  }

  GetAllDocuments(DocumentNo: any): Observable<any> {
    return this.crudService.get('Profile/GetAllDocuments?DocumentNo=' + DocumentNo);

  }


  GetSBU(SBUCode: string): Observable<any> {
    return this.crudService.get<any>('Profile/GetEmployeeDetails?SBUCode=' + SBUCode);
  }

  GetProfileDetails(): Observable<any> {
    const userId = (sessionStorage.getItem('userId') || '').trim();
    return this.crudService.get<any>('Profile/GetProfileDetails?UserId=');
  }

  GetProfileDetailsByProfileId(ProfileID: string): Observable<any> {
    return this.crudService.get<any>('Profile/GetProfileDetailsByProfileId?ProfileID=' + ProfileID);
  }

  UpdateStatus(ProfileData: any): Observable<any> {
    return this.crudService.post<any>('Profile/UpdateStatus', ProfileData);
  }

}
